module.exports = __webpack_public_path__ + "assets/webgl/LM_3_1.jpg.c5489705.webp";